import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";
import useAllPlayers from "../../hooks/queryResults/useAllPlayers";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useLeagueSeason from "../../hooks/queryResults/useLeagueSeason";
import useRosters from "../../hooks/queryResults/useRosters";
import useTeam from "../../hooks/queryResults/useTeam";
import useUserTeam from "../../hooks/queryResults/useUserTeam";
import useAdminMode from "../../hooks/useAdminMode";
import SortUtil from "../../util/sortUtil";
import Box from "../layout/Box";
import LeaguePlayers from "../league/LeaguePlayers";
import PlayersTable from "../league/PlayersTable";
import PlayerSeasonStatsTable from "../player/PlayerSeasonStatsTable";
import Loading from "../ui/Loading";
import TabSection from "../ui/TabSection";
import TeamBanner from "./TeamBanner";
import TeamRosterMove from "./TeamRosterMove";
import TeamTransactions from "./TeamTransactions";
import TeamWaiversRequests from "./TeamWaiversRequests";

export default function TeamRosterPage() {
  const location = useLocation();
  const { leagueSeason, leagueQuery } = useLeagueSeason();
  const { team, teamsQuery } = useTeam();
  const userTeam = useUserTeam();
  const adminMode = useAdminMode();
  const { rostersData, rostersQuery } = useRosters();
  const { playersData, playersQuery } = useAllPlayers();

  const { state } = location;

  const [playersIn, setPlayersIn] = useState(state?.playersIn || []);
  const [playersOut, setPlayersOut] = useState(state?.playersOut || []);

  const isLoading = useIsLoading(
    team,
    teamsQuery,
    leagueSeason,
    leagueQuery,
    rostersData,
    rostersQuery,
    playersData,
    playersQuery
  );
  if (isLoading) return <Loading />;

  const isAuthorized = adminMode || userTeam.obj.id === team.obj.id;

  const { limitMoves } = leagueSeason.obj.settingsRoster;
  const movesRemaining = team.obj.movesRemaining;

  const roster = rostersData.rosters.teams[team.obj.id];

  const playersArr = Object.keys(roster.spots)
    .map((num) => roster.spots[num])
    .filter((spot) => !!spot.player)
    .map((spot) => spot.player)
    .map((playerId) => playersData.players[playerId])
    .sort(SortUtil.playerByLineupPos);

  const handleAdd = (playerId) => {
    setPlayersIn([playerId]);
    scroll.scrollToTop({ duration: 250 });
  };

  const handleDrop = (playerId) => {
    setPlayersOut([playerId]);
    scroll.scrollToTop({ duration: 250 });
  };

  const rosterTable = (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <PlayersTable
        players={playersArr}
        playersToShow={playersArr}
        pageSize={50}
        onClickDrop={handleDrop}
      />
    </div>
  );

  const tables = (
    <div style={{ background: "white", padding: "1rem", color: "black" }}>
      <TabSection
        labels={[team.fullName + " Roster", "All Players"]}
        panels={[
          rosterTable,
          <PlayerSeasonStatsTable
            onClickAdd={handleAdd}
            onClickDrop={handleDrop}
          />,
        ]}
      />
    </div>
  );

  return (
    <div>
      <TeamBanner team={team} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h1>Roster</h1>
        <div>
          {limitMoves ? (
            <span style={{ fontSize: "0.9rem" }}>
              Moves remaining:{" "}
              <span
                style={{
                  backgroundColor: movesRemaining <= 3 ? "red" : "none",
                  padding: "0.25rem",
                }}
              >
                {movesRemaining}
              </span>
            </span>
          ) : null}
        </div>
      </div>
      {isAuthorized ? (
        <>
          <TeamWaiversRequests team={team} />
          <TeamRosterMove
            team={team}
            playersIn={playersIn}
            playersOut={playersOut}
            setPlayersIn={setPlayersIn}
            setPlayersOut={setPlayersOut}
          />
        </>
      ) : null}
      {tables}
      <Box title={"transactions"} style={{ marginTop: "2rem" }}>
        <TeamTransactions team={team} />
      </Box>
    </div>
  );
}
